import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  readonly noBreadCrumb = { label: 'Home', url: '' };
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}
  public menuItems: MenuItem[];
  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(
        () =>
          (this.menuItems = this.createBreadcrumbs(this.activatedRoute.root))
    );    
  }  
  public createBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: MenuItem[] = []
  ): MenuItem[] {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }
    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }
      var label =
        child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
      if (label !== ('no-bread-crumb' || null || undefined) && label != "Products" && label != "Details" && label != "literature") {
        breadcrumbs.push({ label, url });
      } else if (label == 'Products') {
        label = child.snapshot.url[2].path; //binding path from route URL
        breadcrumbs.push({ label, url });
      } else if (label == 'Details') {
        if (child.snapshot.url.length > 0) {
          label = child.snapshot.url[child.snapshot.url.length - 1].path;
          breadcrumbs.push({ label, url });
        }
      }      
      else if (label == 'literature') {
        if (child.snapshot.url.length > 0) {
          label = child.snapshot.url[child.snapshot.url.length - 1].path;
          breadcrumbs.push({ label, url });
        }
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}
